import service from '@/libs/request'

export const BaseUrl = 'https://vx.shitankeji.com/'

export function Login (data) {
  return service({
    url: `${BaseUrl}/admin/login/index`,
    method: 'post',
    data
  })
}
//获取用户列表
export function getAllUsers (params) {
  return service({
    url: `${BaseUrl}/admin/User/index`,
    method: 'get',
    params
  })
}
//添加员工
export function addUser(data){
  return service({
    url: `${BaseUrl}/admin/User/add`,
    method: 'post',
    data
  })
}
//编辑员工
export function editUser(data){
  return service({
    url: `${BaseUrl}/admin/User/edit`,
    method: 'post',
    data
  })
}
//删除员工
export function delUser(params){
  return service({
    url: `${BaseUrl}/admin/User/del`,
    method: 'get',
    params
  })
}
//上传头像
export function uploadImg(formData){
  return service({
    url: `${BaseUrl}/admin/Index/upload`,
    method: 'post',
    data: formData,
  })
}
//获取分类
export function getCate(){
  return service({
    url: `${BaseUrl}/admin/User/getCate`,
    method: 'get'
  })
}
//添加任务
export function addTask(formData){
  return service({
    url:`${BaseUrl}/admin/User/addTask`,
    method:'post',
    data:formData
  })
}
//编辑任务
export function editTask(formData){
  return service({
    url:`${BaseUrl}/admin/User/editTask`,
    method:'post',
    data:formData
  })
}
//删除任务
export function delTask(data){
  return service({
    url:`${BaseUrl}/admin/User/delTask`,
    method:'post',
    data
  })
}

//任务排序
export function orderTaskSort(data){
  return service({
    url:`${BaseUrl}/admin/User/taskSort`,
    method:'post',
    data
  })
}

//任务列表
export function getTaskList(data){
  return service({
    url:`${BaseUrl}/admin/User/taskList`,
    method:'post',
    data
  })
}

//获取任务
export function getSimpleTask(data){
  return service({
    url:`${BaseUrl}/admin/User/getTask`,
    method:'post',
    data
  })
}

//提交试卷
export function addQuestions(data){
  return service({
    url:`${BaseUrl}/admin/User/addQuestions`,
    method:'post',
    data
  })
}
//单独入库
export function addQuestionsBank(data){
  return service({
    url:`${BaseUrl}/admin/User/addQuestionsBank`,
    method:'post',
    data
  })
}
export function getQuestionBankList(data){
  return service({
    url:`${BaseUrl}/admin/User/getQuestionBankList`,
    method:'post',
    data
  })
}
export function add_question_bank(data){
  return service({
    url:`${BaseUrl}/admin/User/add_question_bank`,
    method:'post',
    data
  })
}
export function edit_question_bank(data){
  return service({
    url:`${BaseUrl}/admin/User/edit_question_bank`,
    method:'post',
    data
  })
}
export function delBankquestion(data){
  return service({
    url:`${BaseUrl}/admin/User/del_question_bank`,
    method:'post',
    data
  })
}
export function getBookQuestionsList(data){
  return service({
    url:`${BaseUrl}/admin/User/get_book_questions`,
    method:'post',
    data
  })
}
export function downBookQuestion(data){
  return service({
    url:`${BaseUrl}/admin/User/downBookQuestion`,
    method:'post',
    data
  })
}
export function getBookUnit(data){
  return service({
    url:`${BaseUrl}/admin/User/getBookUnit`,
    method:'post',
    data
  })
}
export function addBookUnit(data){
  return service({
    url:`${BaseUrl}/admin/User/addBookUnit`,
    method:'post',
    data
  })
}
export function delBookUnit(data){
  return service({
    url:`${BaseUrl}/admin/User/delBookUnit`,
    method:'post',
    data
  })
}
//获取试卷
export function getQuestions(data){
  return service({
    url:`${BaseUrl}/admin/User/getQuestions`,
    method:'post',
    data
  })
}

//设置
export function getclasses(data){
  return service({
    url:`${BaseUrl}/admin/User/getCateS`,
    method:'post',
    data
  })
}
//修改类型
export function editClasses(data){
  return service({
    url:`${BaseUrl}/admin/User/editCate`,
    method:'post',
    data
  })
}
export function addclasses(data){
  return service({
    url:`${BaseUrl}/admin/User/addCate`,
    method:'post',
    data
  })
}
//删除员工
export function delClasses(data){
  return service({
    url: `${BaseUrl}/admin/User/delCate`,
    method: 'post',
    data
  })
}

//获取模板
export function getModelDetail(data){
  return service({
    url:`${BaseUrl}/admin/User/getModelDetail`,
    method: 'post',
    data
  })
}
//保存模板
export function addModel(data){
  return service({
    url:`${BaseUrl}/admin/User/addModel`,
    method: 'post',
    data
  })
}

// // 用户激活码兑换相关接口
// export function redeemActivationCode(activeCode) {
//   return service({
//     url: `${BaseUrl}/api/Order/activate`,
//     method: 'post',
//     data: { activeCode }
//   })
// }

// // 获取用户权益列表
// export function getUserEntitlements() {
//   return service({
//     url: `${BaseUrl}/api/Order/getEntitlements`,
//     method: 'post'
//   })
// }

// // 检查用户特定权益
// export function checkUserEntitlement(data) {
//   return service({
//     url: `${BaseUrl}/api/Order/checkEntitlement`,
//     method: 'post',
//     data
//   })
// }

// // 获取用户激活记录
// export function getUserActivationHistory() {
//   return service({
//     url: `${BaseUrl}/api/Order/getActivationHistory`,
//     method: 'post'
//   })
// }

export function getErrorCorrections(data){
  return service({
    url:`${BaseUrl}/admin/Error/index`,
    method: 'post',
    data
  })
}

export function deleteErrorCorrection(data){
  return service({
    url:`${BaseUrl}/admin/Error/delete`,
    method:'post',
    data
  })
}

export function updateErrorStatus(data){
  return service({
    url:`${BaseUrl}/admin/Error/updateStatus`,
    method:'post',
    data
  })
}

export function getErrorCategories() {
  return service({
    url:`${BaseUrl}/admin/Error/category`,
    method: 'get'
  })
}

export function addErrorCategory(data) {
  return service({
    url:`${BaseUrl}/admin/Error/addCategory`,
    method: 'post',
    data
  })
}

export function getVipQuestionList(data){
  return service({
    url:`${BaseUrl}/admin/User/getVipQuestionList`,
    method:'post',
    data
  })
}

export function deleteVipQuestion(data){
  return service({
    url:`${BaseUrl}/admin/User/deleteVipQuestion`,
    method:'post',
    data
  })
}

// VIP组卷配置相关API
// 初始化科目组卷配置
export function initVipPaperConfig(data){
  return service({
    url:`${BaseUrl}/admin/VipPaperConfig/initPaperConfig`,
    method:'post',
    data
  })
}

// 获取科目组卷配置
export function getVipPaperConfig(data){
  return service({
    url:`${BaseUrl}/admin/VipPaperConfig/getPaperConfig`,
    method:'post',
    data
  })
}

// 批量更新组卷配置
export function batchUpdateVipPaperConfig(data){
  return service({
    url:`${BaseUrl}/admin/VipPaperConfig/batchUpdatePaperConfig`,
    method:'post',
    data
  })
}

// 更新单题组号
export function updateVipQuestionGroup(data){
  return service({
    url:`${BaseUrl}/admin/VipPaperConfig/updateQuestionGroup`,
    method:'post',
    data
  })
}

export function saveVipQuestionTypeSettings(data){
  return service({
    url:`${BaseUrl}/admin/VipPaperConfig/saveVipQuestionTypeSettings`,
    method:'post',
    data
  })
}

export function getVipQuestionTypeSettings(data){
  return service({
    url:`${BaseUrl}/admin/VipPaperConfig/getVipQuestionTypeSettings`,
    method:'post',
    data
  })
}

export function saveTaskPdf(data){
  return service({
    url:`${BaseUrl}/admin/VipPaperConfig/saveTaskPdf`,
    method:'post',
    data
  })
}

// VIP题型纠错
export function getVipTypeCorrects(data){
  return service({
    url:`${BaseUrl}/admin/VipCorrect/getVipTypeCorrects`,
    method:'post',
    data
  })
}

export function updateVipTypeCorrectStatus(data){
  return service({
    url:`${BaseUrl}/admin/VipCorrect/updateVipTypeCorrectStatus`,
    method:'post',
    data
  })
}

export function delVipTypeCorrect(data){
  return service({
    url:`${BaseUrl}/admin/VipCorrect/delVipTypeCorrect`,
    method:'post',
    data
  })
}

// 管理端订单列表（筛选 + 分页）
export function getAdminOrderList(data){
  return service({
    url:`${BaseUrl}/admin/OrderManage/list`,
    method:'post',
    data
  })
}
